import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { TranslationService } from "./i18n";
// language list
import { locale as enLang } from "./i18n/vocabs/en";
import { locale as thLang } from "./i18n/vocabs/th";
import { ThemeModeService } from "./_metronic/partials/layout/theme-mode-switcher/theme-mode.service";
import { LayoutService } from "./_metronic/layout";
import { LayoutType } from "./_metronic/layout/core/configs/config";

@Component({
  // tslint:disable-next-line:component-selector
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "body[root]",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  baseLayout: LayoutType = "dark-sidebar";
  constructor(
    private translationService: TranslationService,
    private modeService: ThemeModeService,
    private layoutService: LayoutService
  ) {
    // register translations
    this.translationService.loadTranslations(enLang, thLang);
  }

  ngOnInit() {
    this.layoutService.setBaseLayoutType(this.baseLayout);
    this.modeService.init();
  }
}
